import { KeyByAny } from "../interfaces/overview";
import { OverviewType } from "../../app";
import { FilterArrayAction } from "../../common/dataRefining/store/dataRefiningSlice";
import {
  DEFAULT_COLUMN_WIDTH,
  DEFAULT_COLUMNS_CONFIG,
  DEFAULT_PADDING_CELL,
} from "../constants";
import { escapeFilterValue } from "./certificateTree";

// "+" is the delimiter between selected filter values. Escape any literal "+"
// inside a value first so a value such as "NAU > CA > CPCS.A40+A61" survives the
// join (and the backend's split) as a single value instead of being torn into a
// stray "A61" fragment. No-op for values without a "+".
const joinFilterValues = (values: Array<string>): string =>
  values.map(escapeFilterValue).join("+");

export const getKeyFromMetaData = (
  metadata: KeyByAny | null,
  overviewType: OverviewType,
): string => {
  const filterKey: Array<string> | string = metadata?.filterAble?.filterKey;

  if (!filterKey) {
    return "";
  }

  if (Array.isArray(filterKey)) {
    if (overviewType === OverviewType.Archived) {
      return filterKey[1];
    }

    return filterKey[0];
  }

  return filterKey;
};

export const buildFilterUpdateCalls = (
  value: string | Array<string>,
  metadata: KeyByAny | null,
  overviewType: OverviewType,
): Array<FilterArrayAction> => {
  const filterKey: Array<string> | string = metadata?.filterAble?.filterKey;

  if (!filterKey) {
    return [];
  }

  if (Array.isArray(value) && Array.isArray(filterKey)) {
    return filterKey.map((f) => ({
      key: f,
      delimiter: metadata?.filterAble!.delimiter,
      value: joinFilterValues(value),
      overviewType,
    }));
  }

  if (Array.isArray(value)) {
    return [
      {
        key: filterKey as string,
        delimiter: metadata?.filterAble!.delimiter,
        value: joinFilterValues(value),
        overviewType,
      },
    ];
  }

  return [
    {
      key: filterKey as string,
      delimiter: metadata?.filterAble!.delimiter,
      value: value,
      overviewType,
    },
  ];
};

export const getColumnWidth = (key: string, rowsLength: number) => {
  const column = DEFAULT_COLUMNS_CONFIG[key];
  let widthColumn = column?.width ?? DEFAULT_COLUMN_WIDTH;

  // If there are no rows, the cell content has no padding, causing misalignment.
  if (!rowsLength && (!column || column.hasCellPadding)) {
    widthColumn += DEFAULT_PADDING_CELL;
  }

  return widthColumn;
};
